import { css } from 'styled-components';

/** Outer page wrapper: drop marketing gradient on Capacitor, use grouped background */
export const iosNativePageRoot = css`
  body.native-app & {
    min-height: 0 !important;
    background: transparent !important;
    padding: 12px 16px max(28px, env(safe-area-inset-bottom)) !important;
  }
`;

/** Inner content column */
export const iosNativeContent = css`
  body.native-app & {
    max-width: 100% !important;
    gap: 16px !important;
    margin: 0 !important;
  }
`;

export const iosNativeScreenTitle = css`
  body.native-app & {
    font-size: 28px !important;
    font-weight: 700 !important;
    letter-spacing: -0.03em !important;
    text-align: left !important;
    line-height: 1.15 !important;
    margin: 0 !important;
  }
`;

export const iosNativeScreenSubtitle = css`
  body.native-app & {
    text-align: left !important;
    font-size: 15px !important;
    line-height: 1.35 !important;
    color: rgba(60, 60, 67, 0.6) !important;
    max-width: none !important;
  }
`;

/** White grouped “inset” surface */
export const iosNativeInset = css`
  body.native-app & {
    background: #ffffff !important;
    border-radius: 12px !important;
    box-shadow: none !important;
    border: 0.5px solid rgba(60, 60, 67, 0.12) !important;
  }
`;

export const iosNativeHeaderStack = css`
  body.native-app & {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
  }
`;

export const iosNativeResultsCard = css`
  body.native-app & {
    display: flex !important;
    flex-direction: column !important;
    grid-template-columns: unset !important;
    align-items: stretch !important;
    align-content: stretch !important;
    padding: 14px 16px !important;
    gap: 12px !important;
  }
`;

export const iosNativeGridSingleCol = css`
  body.native-app & {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }
`;

export const iosNativeTipsCallout = css`
  body.native-app & {
    box-shadow: none !important;
    border: 0.5px solid rgba(13, 148, 136, 0.28) !important;
    border-radius: 12px !important;
  }
`;

/** Marketing / misc pages with custom containers */
export const iosNativeFluidContainer = css`
  body.native-app & {
    padding: 12px 16px max(28px, env(safe-area-inset-bottom)) !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
`;

export const iosNativeCenterHeaderLeft = css`
  body.native-app & {
    text-align: left !important;
    margin-bottom: 16px !important;
  }
`;

/** Dark hero pages (camera / analysis) — switch to readable light chrome */
export const iosNativeLightHeroTitle = css`
  body.native-app & {
    color: #000 !important;
  }
`;

export const iosNativeLightHeroSubtitle = css`
  body.native-app & {
    color: rgba(60, 60, 67, 0.65) !important;
  }
`;

export const iosNativeGlassCardLight = css`
  body.native-app & {
    background: #ffffff !important;
    border: 0.5px solid rgba(60, 60, 67, 0.12) !important;
    color: #000 !important;
    backdrop-filter: none !important;
  }
`;

export const iosNativeDocumentPage = css`
  body.native-app & {
    padding: 16px !important;
    background: transparent !important;
    max-width: 100% !important;
  }
`;

export const iosNativeMarketingHero = css`
  body.native-app & {
    text-align: left !important;
    padding: 16px 0 24px !important;
    max-width: 100% !important;
    margin: 0 auto !important;
  }
`;

/** Replace gradient logo text with solid brand color on native */
export const iosNativeSolidBrandTitle = css`
  body.native-app & {
    background: none !important;
    -webkit-text-fill-color: #0f766e !important;
    color: #0f766e !important;
    text-align: left !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;
